/**
 * Mission entity -- Domain model for missions.
 *
 * @module domain/entities/Mission
 */

export const MISSION_STATUSES = ['active', 'completed', 'cancelled'];
export const MISSION_PRIORITIES = ['critical', 'high', 'medium', 'low'];

export const PRIORITY_RANK = { critical: 1, high: 2, medium: 3, low: 4 };

export const PRIORITY_STYLE = {
  critical: { label: 'CRITICAL', color: '#ff2d55', bg: 'rgba(255,45,85,0.18)', border: '#ff2d55' },
  high:     { label: 'HIGH',     color: '#ff9f0a', bg: 'rgba(255,159,10,0.18)', border: '#ff9f0a' },
  medium:   { label: 'MEDIUM',   color: '#8e8e93', bg: 'rgba(142,142,147,0.18)', border: '#8e8e93' },
  low:      { label: 'LOW',      color: '#0a84ff', bg: 'rgba(10,132,255,0.18)', border: '#0a84ff' }
};

export function createMission({ code, title, description, rewardNexos, status, priority }) {
  return {
    id: null,
    code: code || '',
    title: title || '',
    description: description || '',
    rewardNexos: rewardNexos || 10,
    status: MISSION_STATUSES.includes(status) ? status : 'active',
    priority: MISSION_PRIORITIES.includes(priority) ? priority : 'medium',
    instructionCodes: [],
    taskIds: [],
    createdAt: null,
    updatedAt: null
  };
}
